// extracted by mini-css-extract-plugin
export default {"price":"card_price__eo406","card":"card_card__XoCn7","cardName":"card_cardName__nT72w"};